import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

export const get = (companyId) => axios.get(`/companies/${companyId}`);

export const getCompany = (companyId) => {
  return axios.get(`/companies/${companyId}?isDashboard=true`);
};

export const getCompanyOfficials = (companyId, params) =>
  axios.get(
    `/companies/${companyId}/company-officials?${getQueryString(params)}`
  );

export const getCompanyBeneficialOwners = (companyId) =>
  axios.get(`/companies/${companyId}/beneficial-owners`);

export const getOfficial = (companyId, officialId, queryParams) =>
  axios.get(
    `/companies/${companyId}/officials/${officialId}?${getQueryString(queryParams)}`
  );

export const getManageCompanyTransactions = (companyId) =>
  axios.get(`/companies/${companyId}/manage-company-transactions`);

const companyDashboardDataService = {
  get,
  getCompany,
  getCompanyOfficials,
  getCompanyBeneficialOwners,
  getOfficial,
  getManageCompanyTransactions,
};

export default companyDashboardDataService;
